import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './GalleryNavSection.css';

// Video imports
import video1 from '../../assets/video-1.mp4';
import video2 from '../../assets/video-2.mp4';
import video3 from '../../assets/video-3.mp4';
import video4 from '../../assets/video-4.mp4';
import video5 from '../../assets/video-11.mp4';
import video6 from '../../assets/video-6.mp4';
import video7 from '../../assets/video-7.mp4';
import video8 from '../../assets/video-8.mp4';
import video9 from '../../assets/video-9.mp4';
import video10 from '../../assets/video-10.mp4';

const videos = [
  { type: 'video', src: video1 },
  { type: 'video', src: video2 },
  { type: 'video', src: video3 },
  { type: 'video', src: video4 },
  { type: 'video', src: video5 },
  { type: 'video', src: video6 },
  { type: 'video', src: video7 },
  { type: 'video', src: video8 },
  { type: 'video', src: video9 },
  { type: 'video', src: video10 },
];

// Use only videos
const mediaItems = videos;

const MediaGallerySection = () => {
  return (
    <section className="media-gallery py-5">
      <Container>
        <h2 className="text-uppercase mb-4">— Media Gallery</h2>
        <Row className="g-4">
          {mediaItems.map((item, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={3}>
              <div className="video-card">
                <video
                  src={item.src}
                  className="w-100 rounded"
                  muted
                  autoPlay
                  loop
                  playsInline
                  poster="/videos/thumbnail-placeholder.jpg"
                />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MediaGallerySection;
